import {I18nIndividual as GedcomIndividual} from "../model/gedcom-individual"
import {I18nFamily as GedcomFamily} from "../model/gedcom-family"
import {Input, TableCell} from "semantic-ui-react"
import React from "react"


export const createTextCell = <T extends GedcomIndividual | GedcomFamily>(
    field: keyof T,
    rowIndex: number,
    maxLength: number,
    onChange: (rowIndex: number, field: keyof T, value: any) => void,
    value?: string,
    cellClassName?: string,
    inputClassName?: string
) => (
    <TableCell key={`${field.toString()}-${rowIndex}`} className={cellClassName}>
        <Input
            className={inputClassName}
            value={value ?? ""}
            maxLength={maxLength}
            onChange={e => onChange(rowIndex, field, e.target.value)}
        />
    </TableCell>
)